import { apiSlice } from "../app/api/apiSlice";

export const PaymentTypesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserPaymentTypes: builder.query({
            query: ({user_id}) => `user/payment_types/${user_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Payment_types']
        }),
        createPaymentType: builder.mutation({
            query: (input) => ({
                url: `user/create-payment_type`,
                method: 'POST',
                body: { ...input }
            }),
            invalidatesTags: ['Payment_types']
        }),
        editPaymentType: builder.mutation({
            query: (input) => ({
                url: `user/edit-payment_type/${input.id}`,
                method: 'PUT',
                body: { ...input }
            }),
            invalidatesTags: ['Payment_types']
        }),
        getPaymentTypeById: builder.query({
            query: (id) => `/user/payment-type/${id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Payment_types']
        }),
        deletePaymentType: builder.mutation({
            query: (id) => ({
                url: `user/delete-payment_type/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Payment_types']
        }),
    })
})

export const {
    useCreatePaymentTypeMutation,
    useEditPaymentTypeMutation,
    useDeletePaymentTypeMutation,
    useGetPaymentTypeByIdQuery,
    useGetUserPaymentTypesQuery,
} = PaymentTypesApiSlice

